module.exports = __webpack_public_path__ + "img/bg-blog-posts.c04ee145.jpg";